
    import '/mnt/docs/guide/color.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/color.md?type=demo')
};